import React from 'react';

// Add to your existing Signup form. Use controlled value/onChange.
// The values are also persisted in users/{uid}.businessAddress by AuthContext.
const FIELDS = [
  ['street', 'Street address', '123 Main Street', 160, true],
  ['street2', 'Suite / unit (optional)', 'Suite 200', 120, false],
  ['city', 'City', 'Madison', 90, true],
  ['state', 'State / province', 'WI', 65, true],
  ['postalCode', 'ZIP / postal code', '53703', 20, true],
];
export const EMPTY_BUSINESS_ADDRESS = Object.freeze({
  street: '',street2: '',city: '',state: '',postalCode: '',
});

export default function BusinessAddressFields({ value = EMPTY_BUSINESS_ADDRESS, onChange, disabled = false }) {
  return (
    <fieldset className="space-y-4 rounded-xl border border-gray-200 bg-white p-5">
      <legend className="px-2 text-lg font-semibold text-black">Business address</legend>
      <p className="text-sm text-black">The address where Chuko Logic will provide service. You can specify a different location when requesting work.</p>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {FIELDS.map(([name, label, placeholder, maxLength, required]) => (
          <label key={name} className={name === 'street' || name === 'street2' ? 'sm:col-span-2' : ''}>
            <span className="mb-1 block text-sm font-medium text-black">{label}{required ? ' *' : ''}</span>
            <input
              autoComplete={{street:'street-address',street2:'address-line2',city:'address-level2',state:'address-level1',postalCode:'postal-code'}[name]}
              type="text" required={required} disabled={disabled} maxLength={maxLength}
              value={value[name] || ''}
              onChange={event => onChange({ ...value, [name]: event.target.value })}
              placeholder={placeholder}
              className="w-full rounded-lg border border-gray-300 bg-white p-3 text-black focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-200"
            />
          </label>
        ))}
      </div>
    </fieldset>
  );
}
